import React, { useState, useEffect, useRef } from "react";
import img3 from '../../../Assets/Home/22.webp';
import img4 from '../../../Assets/Home/23.webp';
import img5 from '../../../Assets/Home/24.webp';
import { CircleChevronLeft, CircleChevronRight } from "lucide-react";

const images = [ img3, img4, img5];

const Hero = () => {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  const startTimer = () => {
    timerRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 8000);
  };

  useEffect(() => {
    startTimer();
    return () => clearInterval(timerRef.current);
  }, []);

  const goTo = (index) => {
    setCurrent(index);
    clearInterval(timerRef.current);
    startTimer();
  };

  const goPrev = () => {
    goTo((current - 1 + images.length) % images.length);
  };

  const goNext = () => {
    goTo((current + 1) % images.length);
  };

  return (
    <div className="w-full relative overflow-hidden">
      {/* Images */}
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Banner ${index + 1}`}
            className="
              w-full h-auto object-cover 
            "
          />
        ))}
      </div>

      {/* Prev Button */}
      <button
        onClick={goPrev}
        className="absolute left-3 top-1/2 -translate-y-1/2 bg-green-50 hover:bg-black/60 text-green-800 hover:text-white rounded-full w-12 h-12 flex items-center justify-center transition z-10"
      >
       <CircleChevronLeft />
      </button>

      {/* Next Button */}
      <button
        onClick={goNext}
        className="absolute right-3 top-1/2 -translate-y-1/2  bg-green-50 hover:bg-black/60 text-green-800 hover:text-white rounded-full w-12 h-12 flex items-center justify-center transition z-10"
      >
       <CircleChevronRight />
      </button>

      {/* Dot Indicators */}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => goTo(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
              index === current ? "bg-white scale-125" : "bg-white/50"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Hero;